import type { Components, Theme } from "@mui/material/styles";

export const MuiPopper: Components<Theme>["MuiPopper"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // use modal z-index so they are layered by render order
      // this will allow circular nesting where a dialog (which is a modal) has a popper has a select (which is a modal)
      zIndex: theme.zIndex.modal,
    }),
  },
};
